import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';

import { catchError, finalize, map } from "rxjs/operators";

import { ConfigService } from "./config.service";
import { HttpClient } from '@angular/common/http';

import { MessagesService } from "./service.index";
import { ImagenModel } from "../models/auth/_models/ImagenModel";
import { ActionResult } from "../models/auth/_models/action-result";
import { Company, Theme } from "../models/auth/_models/user.model";
// import { htmlAstToRender3Ast } from "@angular/compiler/src/render3/r3_template_transform";

type NewType = BehaviorSubject<boolean>;

@Injectable({
  providedIn: "root",
})
export class CompanyService {
  isLoadingSubject: BehaviorSubject<boolean>;
  loading = false;

  constructor(private http: HttpClient, private configService: ConfigService,   private messagesService: MessagesService,) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
  }


  
  getCompanies(): Observable<Company[]> {
    this.isLoadingSubject.next(true);
    return this.http.get<ActionResult<Company[]>>(`${this.configService.config.apiSecuritySeven}/user/companies`)
      .pipe(
        catchError(err => of(
          this.messagesService.error("Error al traer datos de la empresa"))),
        map((resp: ActionResult<Company[]>) => {
          return resp.result;
        }),
        finalize(() => this.isLoadingSubject.next(false))
      );
  }

  getThemes(): Observable<ActionResult<Theme[]>> {
    return this.http.get<ActionResult<Theme[]>>(`${this.configService.config.apiSecuritySeven}/themes`);
  }

  getThemeById(themeId: string): Observable<ActionResult<Theme>> {
    return this.http.get<ActionResult<Theme>>(`${this.configService.config.apiSecuritySeven}/themes?themeCode=${themeId}`);
  }

  updateTheme(theme: Theme): Observable<ActionResult<string>> {
    return this.http.post<ActionResult<string>>(`${this.configService.config.apiSecuritySeven}/theme/update`, theme);
  }

  deleteTheme(themeId: string): Observable<ActionResult<string>> {
    return this.http.get<ActionResult<string>>(`${this.configService.config.apiSecuritySeven}/theme/delete?themeCode=${themeId}`);
  }

  postImageSelf(imageSource: ImagenModel) {
    //return this.http.get<ActionResult<string>>(`${this.configService.config.apiSelf}/Imagen/get`);
    return this.http.post<boolean>(`${this.configService.config.apiSecuritySeven}/themes/PostImageSelf`, imageSource);
  }

  getimagePos() {
    return this.http.get<ActionResult<ImagenModel>>(`${this.configService.config.apiSecuritySeven}/themes/GetImagePos`);
  }

  postImagePos(imageSource: ImagenModel) {
    //return this.http.get<ActionResult<string>>(`${this.configService.config.apiSelf}/Imagen/get`);
    return this.http.post<boolean>(`${this.configService.config.apiSecuritySeven}/themes/PostImagePos`, imageSource);
  }

}
